export default __webpack_public_path__ + "static/media/gallery_04.0516f3c3.jpg";